"use client";

import * as React from "react";

import { Button } from "./button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";
import { cn } from "@/lib/utils";

/**
 * A one-line explanation on hover / keyboard focus, for a control that is not a <Button>
 * (a raw <button>, a chip, a row link). A <Button> takes `hint` directly instead.
 *
 * `children` must be ONE element that forwards its ref and props. A wrapped Button is told
 * `hint={false}`, so it never adds its own icon tooltip on top of this one.
 */
export function Hint({
  label,
  children,
  side = "bottom",
  className,
}: {
  label: React.ReactNode;
  children: React.ReactElement;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
}) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          {children.type === Button ? React.cloneElement(children as React.ReactElement<{ hint?: false }>, { hint: false }) : children}
        </TooltipTrigger>
        <TooltipContent side={side} className={cn("max-w-64 border-foreground bg-foreground text-background", className)}>
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
